import { render } from "./Botanique3.vue?vue&type=template&id=16241b99&scoped=true"
import script from "./Botanique3.vue?vue&type=script&lang=js"
export * from "./Botanique3.vue?vue&type=script&lang=js"

import "./Botanique3.vue?vue&type=style&index=0&id=16241b99&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16241b99"]])

export default __exports__